module.exports = __webpack_public_path__ + "static/media/swish-demo-choose.0cd4683d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/swish-demo-choose.png
// module id = 433
// module chunks = 0